import React from 'react';
import '../style/reviewElement.css';

import formatDate from '../../../utils/formatDate';
import { t } from 'i18next';

import star_icon from '../../../assets/icons/star.svg';

const ReviewElement = ({ main_image_url, title, price, created_at, rating, reviews_count }) => {
  return (
    <div className="review-element">
      <img
        src={main_image_url}
        alt="Product"
        className="review-image"
      />
      <h3 className="review-title">
        {title}
      </h3>
      <p className="review-price">{price}</p>
      <p className="review-date-right">{t('publishedAt')} {formatDate(created_at)}</p>

      <div className="review-rating">
        <div className="rating-left">
          <img src={star_icon} alt="star" className="rating-star-icon" />
          <span className="rating-value">{t('rating')}{(rating).toString().substring(0, 3)}</span>
        </div>
        <div className="review-count-container">
          <span className="review-count-label">{t('feedbacks')}</span>
          <span className="review-count-value">{reviews_count}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewElement;